import React, {Component} from 'react';
import {connect} from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {Map} from 'immutable';
import {Link} from 'react-router-dom';
import Breadcrumbs from 'components/breadcrumbs';
import Pagination from 'pagination';
import {PageHead} from 'components/header/components';
import {UsersList} from './users-list';
import {Label, UniversalSelectWrapper, SearchFail, SelectWithSearchAsync, UniversalSearchWrapper} from 'components/common';
import Box from 'components/box';
import Spinner from 'spinner';
import Input from 'form/input';
import {ButtonDefault} from '../../components/buttons';

import {searchUsers} from 'redux/actions/admin/users';
import {loadMedicalInstitutions} from 'redux/actions/portal/institutions';

const mapStateToProps = state => ({
  users: state.users.get('users'),
  institutions: state.institutions.get('institutionsList'),
  isFetching: state.users.get('usersAreLoading')
});


const mapDispatchToProps = (dispatch) => ({
  loadInstitutions: search => dispatch(loadMedicalInstitutions('', search)),
  onSearch: (staff_id, institution, offset) =>
    dispatch(searchUsers(staff_id, institution, 25, offset))
});

class Users extends Component {

  constructor(props) {
    super(props);

    this.state = {
      staff_id: '',
      institution: '',
      institutionSelect: ''
    }

    this.changeStaff = this.changeStaff.bind(this);
  }

  selectStyle = {
    border: 'none'
  }

  onChangeInstitutions = institution => {
    let institutionValue = institution ? institution.value : ''
    this.setState({
      institutionSelect: institution,
      institution: institutionValue
    });
  }

  generateInstitutionOptions = results => {
    return results.reduce((arr, item) => {
      const newOption = {value: item.get('id'), type: item.get('institution_type'), label: item.get('full_title') };
      arr.push(newOption);
      return arr
    }, [])
  }

  loadInstitutions = search => {
    if (!search) search=''
    return this.props.loadInstitutions(search)
      .then(response => {
        const results = response.get('results');
        if(!results.size) return Promise.resolve({ options: [] });
        const options = this.generateInstitutionOptions(results);
        return { options }
      })
  }

  changeStaff(event) {
    this.setState({
      staff_id: event.target.value
    })
  }

  componentDidMount() {
		const page = this.props.match.params.page || 1;
		const offset = 25 * (page - 1);
    this.props.onSearch(this.state.staff_id, this.state.institution, offset);
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.match.params.page !== nextProps.match.params.page) {
			const page = nextProps.match.params.page || 1;
			const offset = 25 * (page - 1);
			this.props.onSearch(this.state.staff_id, this.state.institution, offset);
		}
	}

  render() {

    if (this.props.isFetching || !this.props.users) return <Spinner/>;

    return(
      <div>
          <Breadcrumbs>
              <li><Link to="/admin/">Головна</Link></li>
              <li><Link to="/admin/operators">Оператори</Link></li>
          </Breadcrumbs>
        <Box>
          <PageHead>
            <h2>Реєстр операторів</h2>
          </PageHead>
          <UniversalSearchWrapper onSubmit={(event) => {
            event.preventDefault();
            this.props.onSearch(this.state.staff_id, this.state.institution)
          }}>

            <Input
              block
              placeholder="Введіть прізвище"
              label="Пошук за прізвищем"
              value={this.state.staff_id}
              onChange={this.changeStaff}
            />

            <UniversalSelectWrapper>
              <Label>Виберіть установу:</Label>
              <SelectWithSearchAsync
                searchable={true}
                isSearchable={true}
                value={this.state.institutionSelect}
                loadOptions={this.loadInstitutions}
                valueKey={'value'}
                labelkey={'label'}
                onChange={this.onChangeInstitutions}
                style={ this.selectStyle }
                placeholder="Почніть вводити для пошуку..."
                noResultsText="Немає результатів"
              />
            </UniversalSelectWrapper>

            <ButtonDefault type="submit" value="Пошук" />
          </UniversalSearchWrapper>

          {this.props.users.get('results').size > 0 ? (
            <div>
              {this.props.isFetching ? (
                <Spinner />
              ):(
                  <UsersList user={this.props.users.get('results')} />
              )}
            </div>
          ):(
            <SearchFail>Оператори відсутні</SearchFail>
          )}

          <Pagination counts={this.props.users.get('count')} path={`/admin/users/`} matched={this.props.match.params.page} limits={25} />
        </Box>
      </div>
    )
  }
}

Users.propTypes = {
  users: PropTypes.instanceOf(Map),
  isFetching: PropTypes.bool.isRequired
}

export default  withRouter(connect(mapStateToProps, mapDispatchToProps)(Users));



// WEBPACK FOOTER //
// ./src/admin/users/index.js